import { fieldResolverRegistry } from 'customer-flows/quote/resolvers'
import { modelRegistry } from 'customer-flows/quote/models'
import { hasMany, belongsTo } from 'customer-flows/utils/quote'

export default {
  schema: {
    bookingQuotes: hasMany(),
    customer: belongsTo(),
    source: belongsTo('source', { composePolicy: 'always' }),
    channelId: belongsTo('channelId', { composePolicy: 'always' })
  },
  models: modelRegistry,
  resolvers: fieldResolverRegistry
}
